const AgentBotList = () => import('./AgentBotList.vue')

export default [
  {
    name: 'agent-bots',
    path: 'agent-bots',
    component: AgentBotList,
    meta: {
      access: ['org.communication.whatsapp.manage']
    }
  }
]
